import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import './style.css'
import { AuthProvider } from './context/AuthContext'
import AdminReport from './views/admin-report'
import Login from './views/login'
import ClientReport from './views/client-report'
import AdminClients from './views/admin-clients'
import AdminAnalysis from './views/admin-analysis'
import AdminAccess from './views/admin-access'
import ClientAnalysis from './views/client-analysis'
import NotFound from './views/not-found'
import ProtectedRoute from './components/ProtectedRoute'
import AuthCallback from './views/auth-callback'
import { ENABLE_CLIENT_REPORTS } from './utils/featureFlags'

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Switch>
          <Route component={AuthCallback} exact path="/auth/callback" />
          <ProtectedRoute component={AdminReport} exact path="/admin-report" roles={['admin']} />
          <Route component={Login} exact path="/" />
          {ENABLE_CLIENT_REPORTS ? (
            <ProtectedRoute component={ClientReport} exact path="/client-report" roles={['cliente']} />
          ) : (
            <Route
              exact
              path="/client-report"
              render={() => <Redirect to="/client-analysis" />}
            />
          )}
          <ProtectedRoute component={AdminClients} exact path="/admin-clients" roles={['admin']} />
          <ProtectedRoute component={AdminAnalysis} exact path="/admin-analysis" roles={['admin']} />
          <ProtectedRoute component={AdminAccess} exact path="/admin-access" roles={['admin']} />
          <ProtectedRoute component={ClientAnalysis} exact path="/client-analysis" roles={['cliente']} />
          <Route component={NotFound} path="*" />
        </Switch>
        <ToastContainer position="top-right" autoClose={3000} />
      </AuthProvider>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
